import { css } from '@emotion/css'
import { minScreen } from 'utils/mediaQueries'

export const buttonInteraction = css`
  ${minScreen('md')} {
    transition: opacity 0.5s;
    &:hover {
      opacity: 0.7;
    }
  }
`;